"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable dot-notation */
/* eslint-disable jsx-a11y/alt-text */
const react_1 = __importDefault(require("react"));
const assets_1 = require("~/assets");
const WidgetResizeIcon_scss_1 = __importDefault(require("./WidgetResizeIcon.scss"));
function WidgetResizeIcon() {
    return react_1.default.createElement("img", { src: assets_1.svgBasicResizeWidgetIcon, className: WidgetResizeIcon_scss_1.default['icon'] });
}
exports.default = WidgetResizeIcon;
